import Vue from 'vue';
import Vuex from 'vuex';

import { app, alert, cookiesAccepted, copyManuallyDialog } from './modules/global';
import user from './modules/user';
import auth from './modules/auth';
import announcements from './modules/announcements';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    alert,
    user,
    auth,
    announcements,
    cookiesAccepted,
    copyManuallyDialog
  },
  actions: {
    clearStorage(store) {
      store.dispatch('user/clearUserdata');
    },
  },
});
